// extracted by mini-css-extract-plugin
export default {"container":"CustomDatePicker_container__Olo-Y","withLeftIcon":"CustomDatePicker_withLeftIcon__kGp6P","removeBorder":"CustomDatePicker_removeBorder__jXrAo"};